export default {
  SET_ITEMS(state, items) { state.items = items || []; },
  ADD_ITEM(state, item) { state.items.unshift(item); },
  UPDATE_ITEM(state, item) { const index = state.items.findIndex(x => x.ID === item.ID); if (index !== -1) state.items.splice(index, 1, item); },
  REMOVE_ITEM(state, id) { state.items = state.items.filter(x => x.ID !== id); }
}